import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Quote, ArrowRight } from 'lucide-react';
import type { Story } from '../data/stories';
interface QuoteSliderProps {
  stories: Story[];
  intervalMs?: number;
}
export function QuoteSlider({
  stories,
  intervalMs = 6000
}: QuoteSliderProps) {
  const [current, setCurrent] = useState(0);
  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % stories.length);
  }, [stories.length]);
  const prev = useCallback(() => {
    setCurrent(prev => (prev - 1 + stories.length) % stories.length);
  }, [stories.length]);
  useEffect(() => {
    const timer = setInterval(next, intervalMs);
    return () => clearInterval(timer);
  }, [next, intervalMs]);
  if (stories.length === 0) return null;
  const story = stories[current];
  return <div className="relative bg-gray-50 border-y border-gray-200 py-12 md:py-16" data-id="element-244">
      <div className="container mx-auto px-4" data-id="element-245">
        <div className="max-w-3xl mx-auto text-center" data-id="element-246">
          <Quote size={28} className="text-gray-300 mx-auto mb-4" data-id="element-247" />
          <div className="min-h-[140px] flex items-center justify-center" data-id="element-248">
            <div data-id="element-249">
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed italic mb-4" data-id="element-250">
                "{story.quote}"
              </p>
              <div className="flex items-center justify-center mb-2" data-id="element-251">
                <div className="border border-dashed border-gray-300 w-10 h-10 rounded-full flex items-center justify-center bg-gray-100 mr-3 flex-shrink-0" data-id="element-252">
                  <span className="text-gray-400 text-xs font-medium" data-id="element-253">
                    {story.name.charAt(0)}
                  </span>
                </div>
                <div className="text-left" data-id="element-254">
                  <p className="text-sm font-medium text-gray-900" data-id="element-255">
                    {story.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-256">{story.context}</p>
                </div>
              </div>
              {story.slug && <Link to={`/verhalen/${story.slug}`} className="text-xs font-medium text-gray-500 hover:text-gray-900 hover:underline inline-flex items-center mt-2" data-id="element-257">
                  Lees het volledige verhaal{' '}
                  <ArrowRight size={12} className="ml-1" data-id="element-258" />
                </Link>}
            </div>
          </div>

          {/* Controls */}
          <div className="flex items-center justify-center gap-4 mt-6" data-id="element-259">
            <button onClick={prev} className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-full bg-white hover:bg-gray-50 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-300" aria-label="Vorig verhaal" data-id="element-260">
              <ChevronLeft size={16} data-id="element-261" />
            </button>
            <div className="flex gap-1.5" data-id="element-262">
              {stories.map((_, index) => <button key={index} onClick={() => setCurrent(index)} className={`w-2 h-2 rounded-full transition-colors duration-150 focus:outline-none ${index === current ? 'bg-gray-700' : 'bg-gray-300'}`} aria-label={`Ga naar verhaal ${index + 1}`} data-id="element-263" />)}
            </div>
            <button onClick={next} className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-full bg-white hover:bg-gray-50 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-300" aria-label="Volgend verhaal" data-id="element-264">
              <ChevronRight size={16} data-id="element-265" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}